// extracted by mini-css-extract-plugin
export var sliderRange = "_px-2";
export var sliderRoot = "_px-0";
export var sliderThumb = "_px-3";
export var sliderTrack = "_px-1";